(function ($, _app) {
    _app.utils = _app.utils || {}
    
    const arrayify = v => Array.isArray(v) ? v : [v]

    _app.utils.styles = {
        addClass: function ({cssClasses, selectors}) {
            arrayify(selectors).forEach(e =>
                arrayify(cssClasses)
                    .filter(c => $(e).hasClass(c) === false) 
                    .forEach(c => $(e).addClass(c))
            )               
        },
        removeClass: function({cssClasses, selectors}) {
            arrayify(selectors).forEach(e =>
                arrayify(cssClasses)
                    .filter(c => $(e).hasClass(c) === true) 
                    .forEach(c => $(e).removeClass(c))
            )  
        },
        replaceClass: function({fromClasses, toClasses, selectors}) {
            fromClasses = arrayify(fromClasses)
            toClasses = arrayify(toClasses)
            const classTransforms = fromClasses.map((c,i) => [c,toClasses[i]])
            arrayify(selectors).forEach(e => {
                classTransforms.forEach(([f,t],_) => {
                    if ($(e).hasClass(f)) {
                        this.removeClass({cssClasses: f, selectors})
                        this.addClass({cssClasses: t, selectors})
                    }
                })
            })
        },
        removeContainer: function ({selectors}) {
            this.removeClass({cssClasses: 'container', selectors})
        },
        addContainer: function ({selectors}) {
            this.addClass({cssClasses: 'container', selectors})
        },
        makeOutlineBtn: function ({selectors}) {
            this.replaceClass({fromClasses: 'btn-primary', toClasses: 'btn-outline-primary', selectors})
            this.replaceClass({fromClasses: 'btn-secondary', toClasses: 'btn-outline-secondary', selectors})
        },
        makeWhiteBtn: function ({selectors}) {
            this.replaceClass({fromClasses: 'btn-primary', toClasses: 'btn-white-primary', selectors})
            this.replaceClass({fromClasses: 'btn-secondary', toClasses: 'btn-white-secondary', selectors})
        },
        makeSelectButtons: function({selectors}) {
            this.addClass({cssClasses: 'btn-select', selectors})
        },
        setIcon: function({selectors, icon}) {
            arrayify(selectors).forEach(e =>
                $(e).prepend(`<span class='icon icon-${icon}'></span>`)
            )
        }
    }
})(jQuery, app);